import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In your frontend, you should call `}<inlineCode parentName="p">{`identify`}</inlineCode>{` as soon as you're able to. `}</p>
    <p>{`Typically, this is every time your `}<strong parentName="p">{`app loads`}</strong>{` for the first time, and directly after your `}<strong parentName="p">{`users log in`}</strong>{`. `}</p>
    <p>{`This ensures that events sent during your users' sessions are correctly associated with them. `}</p>
    <p>{`You only need to call `}<inlineCode parentName="p">{`identify`}</inlineCode>{` once per session, and you should avoid calling it multiple times unnecessarily.`}</p>
    <p>{`If you call `}<inlineCode parentName="p">{`identify`}</inlineCode>{` multiple times with the same data without reloading the page in between, PostHog will ignore the subsequent calls.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      